var _style, _linearGradient, _path, _path2, _linearGradient2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnestopLoaderV10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    enableBackground: "new 0 0 137.3 137.3",
    viewBox: "0 0 137.3 137.3",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:url(#b);}\n\t\t.st1{fill:#0000FF;}\n\t\t.st2{fill:none;stroke:url(#a);stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:17.4229,17.4229;}\n\t")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 69.493,
    x2: 227.46,
    y1: 631.57,
    y2: 566.89,
    gradientTransform: "translate(0 -544)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c09",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00f",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m66 76.7v23.3s-0.1 2.8 2.1-0.2c2.1-3.1 10.9-10.5-2.1-23.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m74.1 84.9v-39.2s0.3-13.6-4-7-9 13.2-9 13.2-4.5 3.4 0 9.7 12.8 16.3 13 23.3z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8.1527,
    x2: 129.1,
    y1: 68.626,
    y2: 68.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c09",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00f",
    offset: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 68.6,
    cy: 68.6,
    r: 55.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    dur: "5s",
    from: "0 70 70",
    repeatCount: "indefinite",
    to: "360 70 70",
    type: "rotate"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnestopLoaderV10);
export default __webpack_public_path__ + "static/media/onestop-loader-v.10.38f3c333.svg";
export { ForwardRef as ReactComponent };